import { put, takeLatest } from 'redux-saga/effects';
import { EditLicense } from '../../reducers/r_index';
import { MessageType, Message } from '../../utils/variables';

import authService from './../../components/api-authorization/AuthorizeService';

// utils
import format from 'date-fns/format';

// worker saga: makes the api call when triggerAction sees the action
export function* runAction({ payload: { pk, new_license_data } }) {
    try {

        let edit_license_data = {
            ProductKey: pk,
            Cliente: (new_license_data.cliente === '' ? null : new_license_data.cliente),
            Email: (new_license_data.email === '' ? null : new_license_data.email),
            DataScadenza: (new_license_data.data_scadenza === null ? null : format(new_license_data.data_scadenza, 'yyyy-MM-dd')),
            CodiceUtente: (new_license_data.codice_utente === '' ? null : new_license_data.codice_utente)
        };

        const token = yield authService.getAccessToken();

        // Creo l'header per l'HttpPost. NB: PRIMA inizializzare headers, POI aggiungere il body contenente il json
        var myHeaders = new Headers();

        if (token) myHeaders.append('Authorization', `Bearer ${token}`);
        myHeaders.append('Content-Type', 'application/json');
        myHeaders.append('Accept', 'application/json');

        var requestObj = {
            method: 'POST',
            headers: myHeaders,
        };

        requestObj.body = JSON.stringify(edit_license_data);

        const response = yield fetch('/Licenses/EditLicense/', requestObj);

        let responseResult = '';

        responseResult = yield response.json();

        if (responseResult === Message.Updated) {
            yield put(EditLicense.creators.editLicenseSuccess({ responseResult }));
        }
        else if (responseResult === Message.NotUpdated) {
            yield put(EditLicense.creators.editLicenseFailed(responseResult));
        }
        else if (responseResult.substring(0, 5) === MessageType.Error) {
            //se il messaggio � un errore, rimuovo [ERR] all'inizio
            yield put(EditLicense.creators.editLicenseFailed(responseResult.substring(5)));
        }
        else yield put(EditLicense.creators.editLicenseFailed(responseResult));

    } catch (e) {
        yield put(EditLicense.creators.editLicenseFailed(e.message)); // failed to fetch data
    }
}

// watcher saga: watches for actions dispatched to the store, starts runAction
export function* triggerAction() {
    yield takeLatest(EditLicense.types.EDIT_LICENSE_REQUEST, runAction);
}